import Navbar, { scrollToSection } from "../components/Navbar";
import Footer from "../components/Footer";
import offerings from "./Offerings";
// import Clients from "./Clients";
import { AutoInit, Carousel, Modal, Toast } from "@materializecss/materialize";
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

function Home() {
  const { getValues, handleSubmit, setValue, reset } = useForm();

  useEffect(() => {
    AutoInit();
    Carousel.init(document.querySelectorAll(".carousel"), {
      indicators: true,
      fullWidth: true,
    });
    setValue("access_key", "32d0cdb9-e133-403c-84d1-c2caf3175b6e");
  }, [setValue]);

  const onSubmit = async (data) => {
    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      }
    });
    const jsonRes = await res.json();
    if (jsonRes.success) {
      new Toast({
        text: "We'll be in contact with you soon!",
        classes: "green",
      });
    } else {
      new Toast({
        text: "Failed to submit message, try again later",
        classes: "red"
      });
    }
    const ele = document.getElementById("contactModal");
    const instance = Modal.getInstance(ele);
    if (instance) instance.close();
    reset();
  };

  const OfferingCard = ({ itemKey }) => {
    const offering = offerings.get(itemKey);
    if (!offering) return null;

    return (
      <div className="solutionCard">
        <p className="cardHeader">
          <span className="valign-wrapper">
            <i className="small material-icons homepage-icons" style={{ marginRight: "0.75rem" }}>
              {offering.icon}
            </i>
            {offering.title}
          </span>
        </p>
        <p className="card-description">{offering.description}</p>
        {offering.outcomes && (
          <ul className="card-outcomes">
            {offering.outcomes.map((outcome) => (
              <li key={outcome}>{outcome}</li>
            ))}
          </ul>
        )}
        <div className="card-spacer" />
        <button
          type="button"
          data-target="contactModal"
          className="modal-trigger request-info"
        >
          Request more information
        </button>
      </div>
    );
  };

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <div id="top" />

        {/* Hero */}
        <section
          className="hero"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/bg_image.jpg)` }}
        >
          <div className="hero__inner">
            <span className="hero__eyebrow">Data consulting for growing teams</span>
            <h1 className="hero__title">Turn your data into decisions you can trust</h1>
            <p className="hero__sub">
              We're a small Canadian team of data engineers and analysts who build clean pipelines,
              reliable reports, and modern cloud warehouses &mdash; without the enterprise overhead.
            </p>
            <div className="hero__cta-row">
              <button
                type="button"
                data-target="contactModal"
                className="modal-trigger cta-primary"
              >
                Book a free discovery call <span aria-hidden="true">&#8594;</span>
              </button>
              <button
                type="button"
                className="cta-secondary"
                onClick={() => scrollToSection('solutions')}
              >
                See our services
              </button>
            </div>
            <p className="hero__trust">
              Trusted by non-profits and growing businesses across Ontario.
            </p>
          </div>
        </section>

        {/* Dark body */}
        <div className="section--dark">
          <div id="content" className="container section" style={{ maxWidth: "100%" }}>

            {/* Solutions intro */}
            <div id="solutions" style={{ paddingBottom: "var(--space-12)" }}>
              <h2>Data Analytics Consulting Services</h2>
              <p className="subtitle">
                At <strong><span style={{ color: 'var(--color-brand-500)' }}>Select Data Labs (SDL)</span></strong>
                , we help businesses unlock the full potential of their data through tailored solutions. Our consultants have years of experience architecting, building, and optimizing data pipelines, so your data is processed, stored, and analyzed efficiently.
              </p>
            </div>

            {/* Solutions buttons */}
            <div>
              <h2>Solutions to support your business</h2>
              <div className="container">
                <div className="row" style={{ height: "10vh" }}>
                  <div className="col m4 s12">
                    <button type="button" className="solutionButton" onClick={() => scrollToSection('businessAnalytics')}>
                      Business & Analytics
                    </button>
                  </div>
                  <div className="col m4 s12">
                    <button type="button" className="solutionButton" onClick={() => scrollToSection('dataEngineering')}>
                      Data Engineering
                    </button>
                  </div>
                  <div className="col m4 s12">
                    <button type="button" className="solutionButton" onClick={() => scrollToSection('cloudInfrastructure')}>
                      Cloud Enablement
                    </button>
                  </div>
                </div>
              </div>

              <div id="businessAnalytics" />
              <h2 className="section-heading--left">Business & Analytics</h2>
              <p className="section-tagline">Make better decisions with data you trust.</p>
              <div className="offerings-grid offerings-grid--2">
                <OfferingCard itemKey="360DataHealthCheck" />
                <OfferingCard itemKey="reportAutomation" />
                <OfferingCard itemKey="dataAugmentation" />
                <OfferingCard itemKey="dataStrategy" />
              </div>
            </div>

            <div id="dataEngineering" />
            <h2 className="section-heading--left">Data Engineering</h2>
            <p className="section-tagline">Pipelines, warehouses, and processing that just work.</p>
            <div className="offerings-grid offerings-grid--2">
              <OfferingCard itemKey="dataIngestion" />
              <OfferingCard itemKey="dataModelingAndWarehousing" />
              <OfferingCard itemKey="realTimeDataProcessing" />
              <OfferingCard itemKey="customEngineeringSolutions" />
            </div>

            <div id="cloudInfrastructure" />
            <h2 className="section-heading--left">Cloud Enablement</h2>
            <p className="section-tagline">Move to the cloud with less risk and lower bills.</p>
            <div className="offerings-grid offerings-grid--3" style={{ marginBottom: "var(--space-16)" }}>
              <OfferingCard itemKey="cloudDataMigrations" />
              <OfferingCard itemKey="cloudDataWarehousing" />
              <OfferingCard itemKey="cloudCostOptimization" />
            </div>

            {/* Outcomes strip */}
            <section className="outcomes">
              <h2>What you get when you work with us</h2>
              <div className="row">
                <div className="col s12 m4">
                  <div className="outcome-card">
                    <span className="outcome-card__icon">
                      <i className="material-icons">schedule</i>
                    </span>
                    <h3 className="outcome-card__title">Faster reporting</h3>
                    <p className="outcome-card__body">
                      Cut hours of manual Excel work each week with automation your team can rely on.
                    </p>
                  </div>
                </div>
                <div className="col s12 m4">
                  <div className="outcome-card">
                    <span className="outcome-card__icon">
                      <i className="material-icons">verified</i>
                    </span>
                    <h3 className="outcome-card__title">Data you can trust</h3>
                    <p className="outcome-card__body">
                      Catch quality issues before your stakeholders do, with pipelines built for accuracy.
                    </p>
                  </div>
                </div>
                <div className="col s12 m4">
                  <div className="outcome-card">
                    <span className="outcome-card__icon">
                      <i className="material-icons">savings</i>
                    </span>
                    <h3 className="outcome-card__title">Predictable cloud spend</h3>
                    <p className="outcome-card__body">
                      Right-size your warehouse and uncover savings of 20&ndash;40% on cloud data costs.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* How we work section */}
            <div id="howWeWork" style={{ background: "white", position: "relative" }}>
              <div style={{ height: "5vh" }} />
              <h2 className="h2-gradient">How we work</h2>
              <div className="custom-shape-divider-top-1735835777">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                  <path d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z" className="shape-fill" />
                </svg>
              </div>

              <div className="row" style={{ margin: "30px" }}>
                <div className="col m6 s12">
                  <div className="aboutUsCard aboutUsCard--left">
                    <p className="aboutUsCardHeader">
                      <span className="valign-wrapper"><i className="medium material-icons homepage-icons">bolt</i>Agile</span>
                    </p>
                    <p className="subtitle" style={{ textAlign: "left" }}>
                      We're a small, talented team of data professionals. We take a systematic approach to solving complex problems quickly and effectively.
                    </p>
                  </div>
                </div>
                <div className="col m6 s12">
                  <div className="aboutUsCard aboutUsCard--right">
                    <p className="aboutUsCardHeader">
                      <span className="valign-wrapper"><i className="medium material-icons homepage-icons">touch_app</i>Simple</span>
                    </p>
                    <p className="subtitle" style={{ textAlign: "left" }}>
                      We believe in simplicity. The cloud and data are complex enough, so we deliver clear, streamlined solutions that work.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row" style={{ margin: "30px" }}>
                <div className="col m6 s12">
                  <div className="aboutUsCard aboutUsCard--left">
                    <p className="aboutUsCardHeader">
                      <span className="valign-wrapper"><i className="medium material-icons homepage-icons">verified_user</i>Dependable</span>
                    </p>
                    <p className="subtitle" style={{ textAlign: "left" }}>
                      Our clients come first. We have the flexibility and expertise to be there when you need us.
                    </p>
                  </div>
                </div>
                <div className="col m6 s12">
                  <div className="aboutUsCard aboutUsCard--right">
                    <p className="aboutUsCardHeader">
                      <span className="valign-wrapper"><i className="medium material-icons homepage-icons">handshake</i>Strategic</span>
                    </p>
                    <p className="subtitle" style={{ textAlign: "left" }}>
                      We collaborate with your team to understand your goals and craft a targeted, effective plan to achieve them.
                    </p>
                  </div>
                </div>
              </div>

              {/* Testimonials */}
              {/* <section className="testimonials">
                <h2 className="h2-gradient">What our clients say</h2>
                <div className="row" style={{ margin: "30px" }}>
                  {Clients.filter((c) => c.quote).map((client) => (
                    <div key={client.name} className="col m6 s12">
                      <div className="testimonial-card">
                        <p className="testimonial-quote">{client.quote}</p>
                        <div className="testimonial-attribution">
                          <div>
                            <p className="testimonial-author">{client.attribution}</p>
                            <p className="testimonial-org">{client.name}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section> */}

              <div style={{ marginTop: "var(--space-16)" }} />
              <h2 className="h2-gradient">We're tool agnostic</h2>
              <h2 style={{ marginBottom: "0", color: "black" }}>We'll meet your data wherever it lives.</h2>
              <div style={{ marginTop: "3vw", marginLeft: "10vw", marginRight: "10vw" }}>
                <img
                  src="img/tools.png"
                  className="centered-image"
                  alt="A collage of data tools we work with"
                />
              </div>
              <br />
              <br />
              <br />

              {/* Contact modal */}
              <div id="contactModal" className="modal contact-modal">
                <div className="modal-content">
                  <h2 className="h2-gradient contact-modal__title">Get in touch</h2>
                  <p className="contact-modal__lede">
                    Tell us a bit about your team and what you're trying to solve. We'll be back in touch within one business day.
                  </p>
                  <form className="contact-form" onSubmit={handleSubmit(onSubmit)} noValidate>
                    <div className="contact-form__field">
                      <label className="contact-form__label" htmlFor="name">Name</label>
                      <div className="contact-form__input-wrap">
                        <i className="material-icons contact-form__icon" aria-hidden="true">account_circle</i>
                        <input
                          id="name"
                          type="text"
                          name="name"
                          className="contact-form__input"
                          placeholder="Your name"
                          value={getValues("name") || ""}
                          onChange={(e) => setValue("name", e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="contact-form__field">
                      <label className="contact-form__label" htmlFor="email">Email</label>
                      <div className="contact-form__input-wrap">
                        <i className="material-icons contact-form__icon" aria-hidden="true">email</i>
                        <input
                          id="email"
                          type="email"
                          name="email"
                          className="contact-form__input"
                          placeholder="you@company.com"
                          value={getValues("email") || ""}
                          onChange={(e) => setValue("email", e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="contact-form__field">
                      <label className="contact-form__label" htmlFor="message">What can we help you with?</label>
                      <textarea
                        id="message"
                        name="message"
                        className="contact-form__textarea"
                        placeholder="A few sentences about your goals or current data setup..."
                        maxLength="500"
                        value={getValues("message") || ""}
                        onChange={(e) => setValue("message", e.target.value)}
                        required
                      />
                    </div>

                    <label className="contact-form__consent">
                      <input type="checkbox" required />
                      <span>I consent to being contacted by Select Data Labs Inc.</span>
                    </label>

                    <div className="contact-form__actions">
                      <button type="submit" className="send-contact-btn">Send message</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Home;
